import React, { useState, useEffect, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import DataClient from "../../../../../Service/general_data_service";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomSelect from "../../../../../Components/CustomSelect";
import CustomInput from "../../../../../Components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { FormHelperText } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "460px",
    padding: theme.spacing(3),
  },

  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",
    "& button": {
      // marginRight: "20px",
    },
  },
  autoComplete: {
    fontSize: "16px"
  }
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="subtitle1">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageCoachRateCard(props) {
  const classes = useStyles();
  const { action, handleClose, data } = props;

  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [feildName, setFeildName] = useState("");
  const [openNewFeild, setOpenNewFeild] = useState("");
  // const message = useContext(ToastMessageContext);
  const global_data_common = useSelector((state) => state.commonReducer);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [internalJobTitlesArr, setInternalJobTitlesArr] = useState([]);
  const [currenciesArr, setCurrenciesArr] = useState([]);
  const [value, setValue] = React.useState('');
  const [value1, setValue1] = React.useState('');
  const [levelData, setLevelData] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const dataObject = {
    region_name: '',
    currency: '',
  }
  const [userData, setUserData] = useState(dataObject);

  useEffect(() => {
    setUserData(data);
  }, [data]);

  // listing_global_countries
  useEffect(() => {
    DataService.getData({}, "listing_global_countries")
      .then((response) => {
        let internalJobTitlesLocalArr = [];
        response.country_lists.map((option) => {
          (internalJobTitlesLocalArr.push(option.value))
        })

        internalJobTitlesArr.length = 0;
        setInternalJobTitlesArr(internalJobTitlesArr.concat(internalJobTitlesLocalArr))
        setLoading(false);
      })
  }, [])
  useEffect(() => {
    DataService.getData({}, "all_organisation_dropdowns")
      .then((response) => {
        let currenciesLocalArr = [];

        response.currencies.map((option) => {
          (currenciesLocalArr.push(option.value))
        })
        currenciesArr.length = 0;
        setCurrenciesArr(currenciesArr.concat(currenciesLocalArr))
        setLoading(false);
      })
  }, [])

  const setOpen = () => {
    setOpenNewFeild("open");
    setOpenNewFeildDialog(true);
  };
  const handleNewFeildClose = () => {
    setOpenNewFeildDialog(false);
  };
  const [fieldError,setFieldError] = React.useState({region:false,currency:false});
  
  const handleCreate = (formData) => {
    var flag = true;
    if (value === "" || value1 === "") {
      flag = false;
      if(value === ""){
        setFieldError(prev=>{return {...prev,region:true}})
      }
      if(value1 === ""){
        setFieldError(prev=>{return {...prev,currency:true}})
      }
    }

    if (flag) {
      setSubmitClickFlag(true)
      DataService.createData({ organisation_id: props.organisationId, region_name: value, currency: value1 }, "coaching_rate_cards")
        .then((res) => {
          console.log(`res.errors`, res)
          if (res.success) {
            handleClose(res.data);
            props.CoachinRate();
          } else {
            console.log(`res.errors`, res)
            setSubmitClickFlag(true)
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(`err134`, err)
          // setErrorMessage(err?.errors[0])
          setLoading(false);
        });
    }
    else {
      setSubmitClickFlag(true)
    }
  };
  const onChangeItem = (selectedItemValue, inputId) => {
    console.log(selectedItemValue, inputId);
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const handleUpdate = (formData) => {
    const statusData = {
      organisation_id: props.organisationId,
      available_region_id: data.id,
      currency: value1 || userData.currency,
      region_name: value || userData.region_name,
      // ...userData
    }
    var flag = true;
    if (userData.region_name === "" || userData.currency === "") {
      flag = false;
      if(userData.region_name === ""){
        setFieldError(prev=>{return {...prev,region:true}})
      }
      if(userData.currency === ""){
        setFieldError(prev=>{return {...prev,currency:true}})
      }
    }

    if (flag) {
      setSubmitClickFlag(true)
      DataClient.update(statusData, `/rate_cards/update_available_region`)
        .then((res) => {
          if (res.success) {
            console.log(`res.errors`, res.errors)
            handleClose(res.data);
            props.CoachinRate();
          } else {
            console.log(`res.errors`, res.errors)
            setSubmitClickFlag(true)
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
    else {
      setSubmitClickFlag(true)
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      console.log(iterator);
    }

    if (action === "create") {
      handleCreate(formData);
    } else if (action === "edit") {
      handleUpdate(formData);
    }
  };
  return (
    <div>
      <Dialog
        // maxWidth={"xl"}
        // style={{
        //   height: "70%",
        // }}
        maxWidth={"sm"}
        //   fullWidth={true}
        style={{ height: '70%', }}
        open={true}
        // disableBackdropClick
        // disableEscapeKeyDown
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          // style={{
          //   display: 'flex',
          //   justifyContent: 'flex-start'

          //   // margin: "0px auto",
          // }}
          style={{
            paddingTop: "30px",
            paddingLeft: "47px",
            textTransform: "none"
          }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {action === "edit" ? "Edit region" : "Create region"}
        </DialogTitle>
        <DialogContent
          style={{
            margin: "0px auto",
          }}
        >
          {action !== "delete" ? (
            <div className={classes.formWrapper}>
              <Typography
                variant="subtitle2"
                color="secondary"
                className={classes.title}
              >
                {/* {action !== "edit" ? `${action}Modules` :''}  */}
              </Typography>
              <form onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                >

                  <React.Fragment>
                    <Grid item xs={4}>
                      <Typography
                        variant="h2"
                        color="secondary"
                        className={classes.title}
                      >
                        Region name
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Autocomplete
                        value={value || userData?.region_name}
                        onChange={(event, newValue) => {
                          if (newValue === null) {

                            newValue = "";
                          }
                          setValue(newValue);
                          if(newValue !==""){
                            setFieldError((prev)=>{return{...prev,region:false}})
                          }
                        }}
                        classes={{
                          input: classes.autoComplete,
                          option: classes.autoComplete
                        }}
                        defaultValue={userData?.region_name}
                        id="controllable-states-demo"
                        options={internalJobTitlesArr}
                        getOptionLabel={(option) => option}
                        // style={{ width: 250 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select country or region"
                            variant="outlined"
                            InputLabelProps={{ style: { fontSize: "16px", fontFamily: "Open Sans" } }}
                            autoFocus
                            error={fieldError.region}
                            helperText={fieldError.region ?"Please select a region" :""}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        variant="h2"
                        color="secondary"
                        className={classes.title}
                      >
                        Currency name
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>

                      {/* <CustomSelect labelText="Select Currency" id="currency" displayEmpty variant="outlined"
                        itemArr={currenciesArr}
                        helperText={(submitClickFlag && (userData?.currency === "" || userData?.currency === undefined)) ? "* Please select currency" : ""}
                        error={(submitClickFlag && userData?.currency === "") ? true : false}
                        parentcall={onChangeItem} defaultValue={userData?.currency} /> */}

                      <Autocomplete
                        value={value1 || userData?.currency}
                        onChange={(event, newValue) => {
                          if (newValue === null) {

                            newValue = "";
                          }
                          setValue1(newValue);
                          if(newValue !==""){
                            setFieldError((prev)=>{return{...prev,currency:false}})
                          }
                        }}
                        classes={{
                          input: classes.autoComplete,
                          option: classes.autoComplete
                        }}
                        defaultValue={userData?.currency}
                        id="controllable-states-demo"
                        options={currenciesArr}
                        getOptionLabel={(option) => option}
                        // style={{ width: 250 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select currency"
                            variant="outlined"
                            error={fieldError.currency}
                            helperText={fieldError.currency ?"Please select a currency" :""}
                          />
                        )}
                      />
                    </Grid>
                    <FormHelperText style={{ textAlign: 'center', color: 'red' }}>{errorMessage ? errorMessage : ''}</FormHelperText>
                  </React.Fragment>

                </Grid>

                <div className={classes.actionButtons}>
                  <Button disableElevation
                    disabled={loading}
                    type="button"
                    variant={"contained"}
                    onClick={handleClose}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button disableElevation
                    disabled={loading}
                    type="submit"
                    variant={"contained"}
                    color="secondary"
                    style={{ textTransform: "none" }}
                  >
                    {action === "create" ? "Create" : "Update"}
                  </Button>
                </div>
              </form>
            </div>
          ) : (
            <div className={classes.formWrapper}>
              <Typography variant="h2">
                Warning, deleting this region will delete both the region and
                their currency from the ordering list. Are you sure?
              </Typography>
              <div className={classes.actionButtons}>
                <Button disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                >
                  Cancel
                </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                <Button disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  color="secondary"
                >
                  Yes, Confirm
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default ManageCoachRateCard;
